import styled, { css } from 'styled-components';

export const Summary = styled.div<{ $isRead: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px solid #e6e4e2;
  padding: ${(props) => props.theme.spacing['16px']}
    ${(props) => props.theme.spacing['16px']};
  cursor: pointer;

  ${({ $isRead }) =>
    !$isRead &&
    css`
      background-color: #f0f7fa;
    `}
`;

export const Subject = styled.span`
  display: flex;
  font-family: NLRTM-Bold, sans-serif;
  font-weight: bold;
  line-height: 1.75rem;
  font-size: 0.9rem;
  user-select: none;
  margin-right: ${(props) => props.theme.spacing['32px']};
`;

export const DateTime = styled.span`
  display: flex;
  line-height: 1.75rem;
  font-size: 0.9rem;
  user-select: none;
  color: #b3ada7;
`;

export const Details = styled.div<{ $open: boolean; $isRead: boolean }>`
  display: flex;
  flex-direction: column;
  transition: height 0.3s, opacity 0.3s, padding 0.3s;
  opacity: 0;

  ${({ $isRead }) =>
    !$isRead &&
    css`
      background-color: #f0f7fa;
    `}
  ${({ $open }) =>
    $open &&
    css`
      height: 100%;
      opacity: 1;
    `}
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing['16px']}
    ${(props) => props.theme.spacing['16px']};
  line-height: 1.75rem;
  font-size: 0.9rem;

  > div:not(:last-of-type) {
    margin-bottom: ${(props) => props.theme.spacing['16px']};
  }
`;

export const ActionSteps = styled.div`
  display: flex;
  align-items: center;
  min-height: 60px;
  border-bottom: 1px solid #e6e4e2;
  padding: ${(props) => props.theme.spacing['8px']}
    ${(props) => props.theme.spacing['16px']};
`;

export const StyledNotification = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${(props) => props.theme.colors.primary.white};
`;

export const AttachmentsSection = styled.ul`
  list-style: none;
  padding: 0 1rem 1rem 1rem;
  margin: 0;
  border-bottom: 1px solid #e6e4e2;
  font-size: 0.9rem;
`;

export const AttachmentLine = styled.li`
  padding: 0;
`;
